import styles from "@css/modules/ResortSections.module.scss"

export function RestaurantsHeader({ title, description, background }) {
    const backgroundImage = `url(${background.formats.large.url})`
    return (
        <div className={styles.restaurantsHeader}>
            <div style={{ backgroundImage }} className={styles.restaurantsHeaderBg} />
            <div className={styles.restaurantsTitle}>{title}</div>
            <div className={styles.restaurantsDescription}>{description}</div>
        </div>
    )
}
